import { CLEAR_REPORT, SET_OPEN_DOWNLOAD, SET_REPORT_BY_DATE } from 'store/types/report';

export const setOpenDownload = (download) => {
  return {
    type: SET_OPEN_DOWNLOAD,
    payload: download,
  };
};

export const setReportByDate = (reportByDate) => {
  return {
    type: SET_REPORT_BY_DATE,
    payload: reportByDate,
  };
};

export const clearReport = () => {
  return {
    type: CLEAR_REPORT,
    payload: null,
  };
};
